export default __webpack_public_path__ + "887c649745ce6fcace4b5fec68c3222a.svg";